import { useLocation, useNavigate } from "react-router-dom";

// Clicking a link to the page you are already on starts that page fresh (react-router would otherwise do nothing).
export function useFreshNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (to) => (e) => {
    if (pathname !== to || e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    e.preventDefault();
    navigate(to, { state: { fresh: Date.now() } });
  };
}
